import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import reactCondition1 from './assets/images/react-condition1.png';
import reactCondition2 from './assets/images/react-condition2.png';
import reactCondition3 from './assets/images/react-condition3.png';



const ReactLesson13 = () => {
  const [language, changeLanguage] = useState("react");
  const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `
      const Greeting() {
        const [isLoggedIn, setLoggedIn] = useState(false);

        if(isLoggedIn) {
          return <userGreeting />;
        
        }
        return <GuestGreeting />
      }

      `
    );
    const code1 = (
      'text',
      `
      return {
        <div>
        {condition ? <ComponentA /> : <ComponentB />}
        </div>
      };

      `
    );
    const code2 = (
      'text',
      `
      return {
        <div>
        {showComponent &&  <ComponentB />}
        </div>
      };

      `
    );


  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <div className="alert alert-secondary" role="alert">
    <h3><strong>Conditional Rendering</strong></h3>
      <p>Conditional rendering in React refers to the technique of rendering different components or content based on certain conditions or logic defined in the application's JavaScript code. This allows developers to display specific UI elements or components selectively, depending on the state of the application or certain variables.</p>
      <h4 class="text-dark">Methods of Conditional Rendering in React:</h4>
      <ol class="list-group list-group-numbered mb-4">
          <li class="list-group-item"><strong>if Statements:</strong>
          <ol>
              <li>Using regular JavaScript <strong>if</strong> statements to conditionally render components or content.</li>
              <CopyBlock
                        language={"react"}
                        text={code} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               </ol>
          </li>
          <li class="list-group-item"><strong>Ternary Operators:</strong>
          <ol>
              <li>Utilizing the ternary operator <strong>(condition ? true : false)</strong> inside JSX to conditionally render components.</li>
              <CopyBlock
                        language={"react"}
                        text={code1} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               </ol>
          </li>
          <li class="list-group-item"><strong>Logical && Operator:</strong>
          <ol>
              <li>Using the logical <strong>&&</strong> operator to conditionally render content based on a boolean expression.</li>
              <CopyBlock
                        language={"react"}
                        text={code2} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               </ol>
          </li>
      </ol>
      <h4><strong>Use Cases of Conditional Rendering:</strong></h4>
      <ol class="list-group list-group-numbered mb-4">
      <li class="list-group-item"><strong>Authentication:</strong> Show login components if the user is not logged in and authenticated components if they are logged in.</li>
      <li class="list-group-item"><strong>Displaying Data:</strong>Render components based on the availability or absence of data fetched from APIs or databases.</li>
      <li class="list-group-item"><strong>User Interaction:</strong>Show different UI components based on user actions or selections.</li>
      <li class="list-group-item"><strong>Conditional Styling:</strong>Apply different styles to components based on certain conditions.</li>
      </ol>
      <h3><strong>Summary</strong></h3>
      <p>Conditional rendering in React is a powerful feature that allows developers to create dynamic and adaptive user interfaces by selectively displaying components or content based on changing conditions or states within the application.</p>
 
  </div>
      </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson13
  